export enum PreferenceQuestionTypeDto {
  SINGLE = "SINGLE",
  MULTIPLE = "MULTIPLE",
}
